import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { RoleSliceStateTypes } from "../../Slices/roleSlice";
import { getAllRoles } from "../../API/RoleAPI";
import { RoleType } from "../../../dto/Role.dto";
import { showErrorToast } from "../../../app/utils/common/Toast";
import { createRankAPI, getAllRank, updateRankAPI } from "../../API/RankAPI";
import { RankModuleType } from "../../../dto/Rank.dto";
import { RankSliceStateTypes } from "../../Slices/rankSlice";
import { showErrorResponse } from "../../../app/utils/common/showErrorMessage";

export const RankReducer = (
  builder: ActionReducerMapBuilder<RankSliceStateTypes>
) => {
  builder
    .addCase(getAllRank.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      getAllRank.fulfilled,
      (state, action: PayloadAction<RankModuleType[]>) => {
        state.loading = false;
        state.allRanks = action.payload;
      }
    )
    .addCase(getAllRank.rejected, (state, action: PayloadAction<any>) => {
      showErrorResponse(action.payload);
    })

    .addCase(updateRankAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      updateRankAPI.fulfilled,
      (state, action: PayloadAction<RankModuleType[]>) => {
        state.loading = false;
      }
    )
    .addCase(updateRankAPI.rejected, (state, action: PayloadAction<any>) => {
      showErrorResponse(action.payload);
    })

    .addCase(createRankAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      createRankAPI.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
      }
    )
    .addCase(createRankAPI.rejected, (state, action: PayloadAction<any>) => {
      showErrorResponse(action.payload);
    })

};
